import { render, staticRenderFns } from "./URLInput.vue?vue&type=template&id=64a89f52&"
import script from "./URLInput.vue?vue&type=script&lang=ts&"
export * from "./URLInput.vue?vue&type=script&lang=ts&"
import style0 from "./URLInput.vue?vue&type=style&index=0&id=64a89f52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports